// auth action types
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_PERMISSIONS = 'AUTH_PERMISSIONS';
export const AUTH_DISGUISE = 'AUTH_DISGUISE';
export const AUTH_UNDISGUISE = 'AUTH_UNDISGUISE';

export default {
    AUTH_CHECK,
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_REFRESH_TOKEN,
    AUTH_USER,
    AUTH_PERMISSIONS,
    AUTH_DISGUISE,
    AUTH_UNDISGUISE,
};
